/**
 * Tracks whether the current page is the anonymous project canvas.
 *
 * Invariant: the anonymous canvas is the only surface whose visitor has no
 * Clerk session by construction (ownership transfers only at post-signup
 * claim). A stale non-zero `__client_uat` there is therefore never evidence of
 * a signed-in client — only on this surface may `hasSignedInClerkClient`
 * override the cookie once Clerk has loaded. Every other surface treats a
 * loaded, sessionless client with a non-zero cookie as an EXPIRED signed-in
 * session, which must still get the session-expired redirect.
 */

let anonymousSurfaceActive = false;

export function markAnonymousSurface(active: boolean): void {
  anonymousSurfaceActive = active;
}

export function isAnonymousSurfaceActive(): boolean {
  return anonymousSurfaceActive;
}
